<template>
  <div class="references-container">
    <div class="references-title">
      <h1>NOS RÉFÉRENCES</h1>

    </div>
          <div class="breadcrumb">
        <a href="/">Accueil</a> > <a href="/references">Références</a>
      </div>
    <div class="supracare-description">
      <link href="https://fonts.googleapis.com/css2?family=Merriweather:wght@300;400;700&family=Open+Sans:wght@300;400;600&display=swap" rel="stylesheet">
      <!-- Section ajoutée -->
      <div class="content twocolums clearfix">
        <div id="c255" class="frame frame-default frame-type-textmedia frame-layout-0">
          <a id="c849"></a>
          <div class="csc-header csc-header-n1">
            <h1>Nos clients de référence (extrait)</h1>
          </div>
          <div class="ce-textpic ce-right ce-intext">
            <div class="ce-bodytext">
              <p><b>Clients de référence de Supracare </b></p>
                 <p>
                 Supracare collabore avec de nombreux laboratoires et établissements de santé à travers le Maroc.
               </p>
            </div>
          </div>
        </div>

        <div id="c256" class="frame frame-default frame-type-list frame-layout-0">
          <a id="c850"></a>
          <div class="referenzenOuterWrapper clearfix">
               <div class="referenzen-grid">
            <div class="referenzenWrapper">
              <img alt="Almirall" src="@/assets/REFERENCE/BIOLAM.png" width="180" height="51">
            </div>
            <div class="referenzenWrapper">
              <img alt="Apollinaris" src="@/assets/REFERENCE/AIN ITTI.png" width="180" height="96">
            </div>
            <div class="referenzenWrapper">
              <img alt="applichem" src="@/assets/REFERENCE/ANFA LAB.png" width="180" height="53">
            </div>
            <div class="referenzenWrapper">
              <img alt="BAM" src="@/assets/REFERENCE/BANK ALMAGHRIB.png" width="180" height="121">
            </div>
            <div class="referenzenWrapper">
              <img alt="baxter" src="@/assets/REFERENCE/BIOCLINIC.png" width="180" height="59">
            </div>
            <div class="referenzenWrapper">
              <img alt="Bayer" src="@/assets/REFERENCE/BIOLOG.png" width="180" height="81">
            </div>
            <div class="referenzenWrapper">
              <img alt="beckman" src="@/assets/REFERENCE/CASA ANALYSE.png" width="180" height="81">
            </div>
            <div class="referenzenWrapper">
              <img alt="Biohit" src="@/assets/REFERENCE/CBM.png" width="180" height="85">
            </div>
                  <div class="referenzenWrapper">
              <img alt="Almirall" src="@/assets/REFERENCE/BIOLAM.png" width="180" height="51">
            </div>
            <div class="referenzenWrapper">
              <img alt="Apollinaris" src="@/assets/REFERENCE/CBMS.png" width="180" height="96">
            </div>
            <div class="referenzenWrapper">
              <img alt="applichem" src="@/assets/REFERENCE/CHU OUJDA.png" width="180" height="53">
            </div>
            <div class="referenzenWrapper">
              <img alt="BAM" src="@/assets/REFERENCE/CIAMM.png" width="180" height="121">
            </div>
            <div class="referenzenWrapper">
              <img alt="baxter" src="@/assets/REFERENCE/CNSS.png" width="180" height="59">
            </div>
            <div class="referenzenWrapper">
              <img alt="Bayer" src="@/assets/REFERENCE/DERDABI.png" width="180" height="81">
            </div>
            <div class="referenzenWrapper">
              <img alt="beckman" src="@/assets/REFERENCE/INSTITUT PASTEUR MAROC.png" width="180" height="81">
            </div>
            <div class="referenzenWrapper">
              <img alt="Biohit" src="@/assets/REFERENCE/LABO MAC.png" width="180" height="85">
            </div>
              <div class="referenzenWrapper">
              <img alt="Biohit" src="@/assets/REFERENCE/LABO RACINE OULED Z.png" width="180" height="85">
            </div>
              <div class="referenzenWrapper">
              <img alt="Biohit" src="@/assets/REFERENCE/LABO SOFI.png" width="180" height="85">
            </div>
            <div class="referenzenWrapper">
              <img alt="Biohit" src="@/assets/REFERENCE/LCN.png" width="180" height="85">
            </div>
              <div class="referenzenWrapper">
              <img alt="Biohit" src="@/assets/REFERENCE/PANORAMIQUE.png" width="180" height="85">
            </div>
              <div class="referenzenWrapper">
              <img alt="Biohit" src="@/assets/REFERENCE/RMMS.png" width="180" height="85">
            </div>
          </div>
          </div>
          <div class="referenzenTextClear">&nbsp;</div>
          <div class="referenzenItemTextWrapper clearfix"></div>
        </div>
      </div>
      <!-- Fin de la section ajoutée -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReferencesP',
};
</script>

<style scoped>
.references-container {
  padding: 0px 0px;
  background-color: #f9f9f9;
  text-align: justify;
  z-index: 1;
  overflow: hidden;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.references-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: -1;
}

.references-title {
  position: relative;
  background-image: url('C:/Users/PC MAROC/supracare_web/src/assets/img6.jpg');
  background-size: cover;
  background-position: center;
  color: rgb(29, 22, 77);
  padding: 100px 400px;
  font-size: 14px;
  margin: 0 auto;
  text-align: center;
  border-radius: 2px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 1000px;
  z-index: 1;
}

.breadcrumb {
  font-size: 10px;
  color: #888;
  margin-top: 0px;
  padding: 10px 50px;

}

.breadcrumb a {
  color: #1c1c1d;
  text-decoration: none;
  transition: color 0.3s ease;
}

.breadcrumb a:hover {
  color: #0056b3; /* Couleur au survol */
}

.supracare-description {
  padding: 20px 200px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  margin-top: 0px;
  font-family: 'Open Sans', sans-serif;
}

.supracare-description h2 {
  color: #4c4a4d;
  font-size: 1.8rem;
  margin-bottom: 15px;
  font-family: 'Merriweather', serif;
}

.supracare-description p {
  font-size: 1.1rem;
  line-height: 1.75;
  color: #333;
  margin-bottom: 20px;
  font-family: 'Open Sans', sans-serif;
}

/* Styles pour les clients de référence */
.content {
  margin-top: 30px;
}

.referenzen-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 20px;
  margin-top: 30px;
}

.referenzenWrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f4f4f4;
  border-radius: 10px;
  padding: 10px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.referenzenWrapper img {
  max-width: 100%;
  height: auto;
}

.referenzenWrapper:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

@media (max-width: 768px) {
  .references-title {
    font-size: 2rem;
  }

  .supracare-description {
    padding: 20px;
  }

  .supracare-description h2 {
    font-size: 1.5rem;
  }

  .supracare-description p {
    font-size: 1rem;
  }
}

/* Responsive pour les petits écrans */
@media (max-width: 768px) {
  .references-title {
    font-size: clamp(1.5rem, 5vw, 1rem);
    padding: 100px 0px;
  }

  .breadcrumb {
    font-size: 0.9rem;
  }

  .supracare-description {
    padding: 20px;
  }

  .supracare-description h2 {
    font-size: 1.5rem;
  }

  .supracare-description p {
    font-size: 1rem;
  }
}

/* ===================== MODE SOMBRE (auto) ===================== */
@media (prefers-color-scheme: dark){

  /* Fond global + voile sombre doux */
  .references-container{
    background:#0e1720;
    color:#e6edf1;
  }
  .references-container::before{
    background-color: rgba(0,0,0,0.35);
  }

  /* Bandeau image : lisibilité renforcée */
  .references-title{
    color:#0c0c0c;
    box-shadow: 0 10px 32px rgba(0,0,0,.55);
    position: relative;
  }
  .references-title::after{
    content:""; position:absolute; inset:0; pointer-events:none; border-radius:inherit;
    background: linear-gradient(180deg, rgba(0,0,0,.45), rgba(0,0,0,.25));
  }

  /* Fil d’Ariane */
  .breadcrumb{ color:#9fb3c8; }
  .breadcrumb a{ color:#73d8cf; }
  .breadcrumb a:hover{ color:#a5f3ee; }

  /* Bloc description */
  .supracare-description{
    background:#0f1720;
    border:1px solid rgba(255,255,255,.06);
    box-shadow: 0 8px 24px rgba(0,0,0,.55);
  }
  .supracare-description h2{ color:#cde5ff; }
  .supracare-description p{ color:#cfe0e4; }

  /* Grille logos / cartes */
  .referenzenWrapper{
    background:#0f1a24;
    border:1px solid rgba(255,255,255,.06);
    box-shadow: 0 8px 22px rgba(0,0,0,.5);
  }
  .referenzenWrapper:hover{
    transform: scale(1.05);
    box-shadow: 0 14px 28px rgba(0,0,0,.55);
  }
}

/* Micro-ajustement sombre sur tablettes/mobile (ombres un peu plus douces) */
@media (prefers-color-scheme: dark) and (max-width: 768px){
  .references-title{ box-shadow: 0 8px 22px rgba(0,0,0,.55); }
}

</style>
